import { LegalLayout, LegalSection } from "@/components/landing/LegalLayout";

export default function MentionsLegales() {
  return (
    <LegalLayout
      testId="page-mentions-legales"
      eyebrow="Informations légales"
      title="Mentions légales"
      updated="juin 2026"
    >
      <LegalSection title="Éditeur du site">
        <p>Le présent site est édité par&nbsp;:</p>
        <ul className="list-disc space-y-1 pl-5">
          <li><strong>Dénomination&nbsp;:</strong> Leadzi CHR</li>
          <li><strong>Forme juridique&nbsp;:</strong> Entreprise individuelle</li>
          <li><strong>SIRET&nbsp;:</strong> 791 545 387 00049</li>
          <li><strong>Contact&nbsp;:</strong> <a className="text-brand hover:underline" href="mailto:contact@leadzi.fr">contact@leadzi.fr</a></li>
        </ul>
        <p className="text-sm text-ink/50">L'adresse postale du siège peut être communiquée sur simple demande à l'adresse e-mail ci-dessus.</p>
      </LegalSection>

      <LegalSection title="Directeur de la publication">
        <p>Le directeur de la publication est le représentant légal de l'entreprise individuelle Leadzi CHR.</p>
      </LegalSection>

      <LegalSection title="Objet du site">
        <p>
          Ce site est un site vitrine destiné à présenter l'application mobile Leadzi CHR et à
          permettre son téléchargement. Leadzi CHR permet aux commerciaux du secteur CHR
          (café-hôtel-restaurant) de déposer les opportunités commerciales qu'ils ne peuvent pas
          traiter afin de les valoriser.
        </p>
      </LegalSection>

      <LegalSection title="Propriété intellectuelle">
        <p>
          L'ensemble des éléments présents sur ce site (marque « Leadzi CHR », logo, textes, visuels,
          éléments graphiques, mise en page et code) est protégé par le droit de la propriété
          intellectuelle. Toute reproduction, représentation, modification ou exploitation, totale
          ou partielle, sans autorisation écrite préalable de l'éditeur, est interdite.
        </p>
      </LegalSection>

      <LegalSection title="Responsabilité">
        <p>
          L'éditeur s'efforce d'assurer l'exactitude des informations diffusées sur ce site. Il ne
          saurait toutefois être tenu responsable des erreurs, omissions ou d'une éventuelle
          indisponibilité du site. Les informations présentées n'ont pas de valeur contractuelle.
        </p>
      </LegalSection>

      <LegalSection title="Données personnelles & cookies">
        <p>
          Les modalités de traitement des données et l'utilisation des cookies sont détaillées dans
          notre <a className="text-brand hover:underline" href="/politique-confidentialite">Politique de confidentialité</a>.
        </p>
      </LegalSection>

      <LegalSection title="Droit applicable">
        <p>Le présent site est soumis au droit français.</p>
      </LegalSection>
    </LegalLayout>
  );
}
